import React, { FunctionComponent, useCallback, useState } from "react";
import Text, { TextProps } from "./Text";
import { useLocale } from "designSystem/locale";
import Tooltip, { TooltipProps } from "../tooltip/Tooltip";

export interface OverflowTextProps extends Omit<TextProps, "block"> {
	/** properties for tooltip */
	tooltipProps?: Partial<TooltipProps>;
}

const OverflowText: FunctionComponent<OverflowTextProps> = (props) => {
	const loc = useLocale();
	const [overflows, setOverflows] = useState(false);
	const { res, resParams, text, tooltipProps, ...otherTextProps } = props;
	const { title, ...otherTooltipProps } = tooltipProps || {};
	const textFinal = text || loc.resource(res, resParams) || "";

	const contentRef = useCallback((node: HTMLElement) => {
		if (node) {
			setOverflows(node.scrollWidth > node.clientWidth);
		}
	}, [text]);

	return (
		<Tooltip
			PopperProps={{
				container: document.fullscreenElement,
			}}
			disableHoverListener={!overflows}
			title={title || textFinal}
			{...otherTooltipProps}
		>
			<Text
				block
				noWrap
				ref={contentRef}
				text={textFinal}
				{...otherTextProps}
			/>
		</Tooltip>
	);
};

export default OverflowText;